import { render, staticRenderFns } from "./addHandServer.vue?vue&type=template&id=2d0b36bc&scoped=true&"
import script from "./addHandServer.vue?vue&type=script&lang=js&"
export * from "./addHandServer.vue?vue&type=script&lang=js&"
import style0 from "./addHandServer.vue?vue&type=style&index=0&id=2d0b36bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b36bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0b36bc')) {
      api.createRecord('2d0b36bc', component.options)
    } else {
      api.reload('2d0b36bc', component.options)
    }
    module.hot.accept("./addHandServer.vue?vue&type=template&id=2d0b36bc&scoped=true&", function () {
      api.rerender('2d0b36bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/automaticServer/components/addHandServer.vue"
export default component.exports